import Vue from 'vue'
import versions, { setVersions } from './src/versions/versions'
import decorators from './src/decorators/decorators'

const update = () => setVersions(versions)
const _vm_ = new Vue({ data: { versions, decorators, update } })

const versionable = vue => {
  vue.prototype.$versionable = _vm_.$data
}

export default versionable
